'use es6';

import createAction from 'flux-actions/createAction';
import { NAVIGATED_TO_EXTERNAL_PAGE, NAVIGATED_TO_PAGE } from './ActionTypes';
export const navigatedToPage = createAction(NAVIGATED_TO_PAGE, ({
  analyticsPageId,
  contentPageId,
  contentType,
  crmObjectTypeId,
  hasSmartContent,
  hasVideo,
  hubDbTableId,
  isUngatedForApplySharedPageLimits,
  shouldFetchFromSharedPageLimitApi
}) => ({
  analyticsPageId,
  contentPageId,
  contentType,
  crmObjectTypeId,
  hasSmartContent,
  hasVideo,
  hubDbTableId,
  isUngatedForApplySharedPageLimits,
  shouldFetchFromSharedPageLimitApi
}));
export const navigatedToExternalPage = createAction(NAVIGATED_TO_EXTERNAL_PAGE, ({
  id,
  title,
  url
}) => ({
  id,
  title,
  url
}));